// Bootstrap specific functions and styling
jQuery(document).ready(function () {

    // here for each comment reply link of WordPress
    jQuery('.comment-reply-link').addClass('btn btn-sm btn-default');

    // here for the submit button of the comment reply form
    jQuery('#submit, button[type=submit], button, html input[type=button], input[type=reset], input[type=submit]').addClass('btn btn-default');

    // Now we'll add some classes for the WordPress default widgets - let's go
    jQuery('.widget_rss ul').addClass('media-list');

    // Add Bootstrap style for drop-downs
    jQuery('.postform').addClass('form-control');

    // Add Bootstrap styling for tables
    jQuery('table#wp-calendar').addClass('table table-striped');

    jQuery('#submit, .tagcloud, button[type=submit], .comment-reply-link, .widget_rss ul, .postform, table#wp-calendar').show("fast");

});

// jQuery powered scroll to top
jQuery(document).ready(function () {

    //Check to see if the window is top if not then display button
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 100) {
            jQuery('.scroll-to-top').fadeIn();
        } else {
            jQuery('.scroll-to-top').fadeOut();
        }
    });

    //Click event to scroll to top
    jQuery('.scroll-to-top').click(function () {
        jQuery('html, body').animate({scrollTop: 0}, 800);
        return false;
    });

    //Click event to scroll to top
    jQuery('.scroll-to-main, .home-headline-scroll-to-main').click(function (e) {
        e.preventDefault();
        jQuery('html, body').animate({scrollTop: jQuery('#main').offset().top}, 800);
        return false;
    });

});


jQuery(document).ready(function ($) {
        // Slider functions
        $('.home-slide').flexslider({

            animation: "fade",              //String: Select your animation type, "fade" or "slide"
            easing: "swing",                //{NEW} String: Determines the easing method used in jQuery transitions. jQuery easing plugin is supported!
            direction: "horizontal",        //String: Select the sliding direction, "horizontal" or "vertical"
            reverse: false,                 //{NEW} Boolean: Reverse the animation direction
            animationLoop: true,            //Boolean: Should the animation loop? If false, directionNav will received "disable" classes at either end
            smoothHeight: true,            //{NEW} Boolean: Allow height of the slider to animate smoothly in horizontal mode
            startAt: 0,                     //Integer: The slide that the slider should start on. Array notation (0 = first slide)
            slideshow: true,                //Boolean: Animate slider automatically
            slideshowSpeed: 10000,           //Integer: Set the speed of the slideshow cycling, in milliseconds
            animationSpeed: 600,            //Integer: Set the speed of animations, in milliseconds
            initDelay: 0,                   //{NEW} Integer: Set an initialization delay, in milliseconds
            randomize: false,               //Boolean: Randomize slide order
            fadeFirstSlide: true,           //
            // : Fade in the first slide when animation type is "fade"

            // Usability features
            pauseOnAction: false,            //Boolean: Pause the slideshow when interacting with control elements, highly recommended.
            pauseOnHover: false,            //Boolean: Pause the slideshow when hovering over slider, then resume when no longer hovering
            pauseInvisible: true,       		//{NEW} Boolean: Pause the slideshow when tab is invisible, resume when visible. Provides better UX, lower CPU usage.
            useCSS: true,                   //{NEW} Boolean: Slider will use CSS3 transitions if available
            touch: true                    //{NEW} Boolean: Allow touch swipe navigation of the slider on touch-enabled devices
        });

        var $flexSlider = $('.thematics-slider'),
            $backdrop   = $("<div />", {class: 'thematic-backdrop'});

        $flexSlider.flexslider({
            animationLoop: true,            //Boolean: Should the animation loop? If false, directionNav will received "disable" classes at either end
            smoothHeight: true,            //{NEW} Boolean: Allow height of the slider to animate smoothly in horizontal mode
            slideshowSpeed: 5000,           //Integer: Set the speed of the slideshow cycling, in milliseconds
            animationSpeed: 600,            //Integer: Set the speed of animations, in milliseconds
            initDelay: 0,                   //{NEW} Integer: Set an initialization delay, in milliseconds
            // pauseOnHover: true,            //Boolean: Pause the slideshow when hovering over slider, then resume when no longer hovering
            after: function () {
                // Close all modal when sliding
                $flexSlider.find('.more-details-container').addClass('hide');
                $flexSlider.find('.flex-control-nav').removeClass('hide');
            }
        });

        $flexSlider.find('.more-details').on('click', function () {
            var $this        = $(this),
                $moreDetails = $this.parents('.thematic').find('.more-details-container');

            $moreDetails.removeClass('hide');
            $flexSlider.find('.flex-control-nav, .flex-direction-nav').addClass('hide');
            $flexSlider.flexslider('pause');
            $moreDetails.after($backdrop);
            jQuery('html, body').animate({scrollTop: $moreDetails.offset().top - (jQuery('#masthead').height() + 20)}, 800);
        });

        $flexSlider.find('.close').on('click', function () {
            var $this = $(this);
            $this.parents('.thematic').find('.more-details-container').addClass('hide');
            $flexSlider.find('.flex-control-nav, .flex-direction-nav').removeClass('hide');
            $flexSlider.flexslider('play');
            $flexSlider.find('.thematic-backdrop').remove();
        });


        var productSlider,
            $bxSlider        = $('.bxslider'),
            $sliderContainer = $('.seprovence-shop-slider');
        if ($bxSlider.length > 0) {
            function createProductsSlider(width) {
                if (productSlider) {
                    productSlider.destroySlider();
                }
                var options = {
                    slideMargin: 0,
                    captions: true,
                    infiniteLoop: true,
                    pager: false,
                    auto: false,
                    autoHover: true,
                    startSlide: 1,
                    keyboardEnabled: true,
                    touchEnabled : (navigator.maxTouchPoints > 0)
                };

                if (width <= 425) {
                    $.extend(options, {
                        minSlides: 1,
                        maxSlides: 1,
                        moveSlides: 1
                    });
                } else if (width <= 768) {
                    $.extend(options, {
                        minSlides: 2,
                        maxSlides: 2,
                        moveSlides: 2,
                        slideWidth: $sliderContainer.width() / 2
                    });
                } else if (width <= 1024) {
                    $.extend(options, {
                        minSlides: 3,
                        maxSlides: 3,
                        moveSlides: 3,
                        slideWidth: $sliderContainer.width() / 3
                    });
                } else {
                    $.extend(options, {
                        minSlides: 5,
                        maxSlides: 5,
                        slideWidth: $sliderContainer.width() / 5
                    });
                }

                productSlider = $bxSlider.bxSlider(options);
            }

            createProductsSlider(window.outerWidth);
            $(window).on('resize', function () {
                createProductsSlider(window.outerWidth);
            });
        }
    }
);

(function ($) {
    var $document = $(document),
        $masthead = $('#masthead'),
        offset    = $masthead.height();

    $document.scroll(function () {
        var scrollTop = $document.scrollTop();

        if (scrollTop > offset) {
            $masthead.addClass('fixed');
        } else {
            $masthead.removeClass('fixed');
        }
    });
})(jQuery);

(function ($) {
    $('.showForm:enabled').on('click', function () {
        $(this).addClass('hide');
        var $hiddenForm = $('.hiddenForm'),
            target      = $(this).data('target');

        if (target) {
            var $target = $(target);

            if ($target.length > 0) {
                $target.slideDown();
            }
        } else if ($hiddenForm.length > 0) {
            $hiddenForm.slideDown();
        }

    })
})(jQuery);